// Function to update size availability based on selected color
function updateOptionAvailability(optionToUpdate, selectedOptionName, selectedOptionValue) {
  // RE-ENABLED: This function handles sold-out styling for size options
  // Price updates are now handled by product-variant-sync.js to prevent conflicts
  
  const optionInputs = document.querySelectorAll(`input[data-option-name="${optionToUpdate}"]`);

  // Get the index of the option to update and the selected option
  const updateIndex = window.productData.optionNames.indexOf(optionToUpdate);
  const selectedIndex = window.productData.optionNames.indexOf(selectedOptionName);

  if (updateIndex < 0 || selectedIndex < 0) {
    return;
  }

  optionInputs.forEach(input => {
    const label = document.querySelector(`label[for="${input.id}"]`);
    const currentOptionValue = input.value;

    let isAvailable = false;

    if (window.productData && window.productData.variants) {
      window.productData.variants.forEach(variant => {
        if (variant.options[selectedIndex] === selectedOptionValue &&
            variant.options[updateIndex] === currentOptionValue &&
            variant.available) {
          isAvailable = true;
        }
      });
    }

    if (isAvailable) {
      label.classList.remove('sold-out');
      input.disabled = false;
      label.style.background = '';
      const strikeElement = label.querySelector('.sold-out-strike');
      if (strikeElement) {
        strikeElement.remove();
      }
    } else {
      label.classList.add('sold-out');
      input.disabled = false;  // Keep enabled but visually sold out
      label.style.background = 'linear-gradient(to bottom left, #EEEEEE calc(50% - 1px), rgba(var(--text-color) / .2) calc(50% - 1px), rgba(var(--text-color) / .2) calc(50% + 1px), #EEEEEE calc(50% + 1px)) no-repeat';
      if (!label.querySelector('.sold-out-strike')) {
        const strikeElement = document.createElement('span');
        strikeElement.className = 'sold-out-strike';
        label.appendChild(strikeElement);
      }
    }
  });
}

// Wrap event listeners and initial setup in DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
  // Handle color swatch selection for combined products AND standard products
  const colorSwatchLabels = document.querySelectorAll('.opt-label--swatch');
  
  colorSwatchLabels.forEach((label, index) => {
    label.addEventListener('click', function(e) {
      
      // Get the value from the associated radio input
      const radioInput = document.querySelector(`input[id="${this.getAttribute('for')}"]`);
      let colorValue = null;
      
      if (radioInput) {
        colorValue = radioInput.value;
      }
      
      // Check if this is a combined product (has href) or single product (no href)
      const isCombinedProduct = this.hasAttribute('href') && this.href;
      
      if (isCombinedProduct) {
        // For combined products, let the navigation happen naturally
        colorSwatchLabels.forEach(swatch => {
          swatch.classList.remove('is-selected');
        });
        this.classList.add('is-selected');
        return;
      }
      
      // For single products (labels), prevent default behavior and sync with radio buttons
      e.preventDefault();
      
      // Find and check the corresponding radio button
      const radioButton = document.querySelector(`input[data-option-name="Color"][value="${colorValue}"], input[data-option-name="Colour"][value="${colorValue}"]`);
      
      if (radioButton) {
        // Update visual selection first
        colorSwatchLabels.forEach(swatch => {
          swatch.classList.remove('is-selected');
        });
        this.classList.add('is-selected');
        
        // Update color text display
        const colorTextElement = document.querySelector('.js-color-text');
        if (colorTextElement && colorValue) {
          colorTextElement.textContent = colorValue;
        }
        
        // Check the radio button and let the existing theme code handle everything else
        radioButton.checked = true;
        
        // Trigger the existing change event first
        radioButton.dispatchEvent(new Event('change', { bubbles: true }));
        
        // Also trigger our variant sync handler
        setTimeout(() => {
          const variantChangeEvent = new CustomEvent('variant:sync', {
            detail: { 
              optionName: 'Color',
              optionValue: colorValue,
              radioButton: radioButton
            },
            bubbles: true
          });
          document.dispatchEvent(variantChangeEvent);
        }, 10);
        
        // MANUAL VARIANT SYNC: Always run this to ensure proper variant detection
        setTimeout(() => {
          // Get all currently selected options
          const selectedOptions = {};
          document.querySelectorAll('input[data-option-name]:checked').forEach(input => {
            selectedOptions[input.dataset.optionName] = input.value;
          });
          
          // Find the matching variant
          let matchingVariant = null;
          if (window.productData && window.productData.variants) {
            for (const variant of window.productData.variants) {
              let matches = true;
              
              // Dynamic matching based on actual option positions
              Object.keys(selectedOptions).forEach(optionName => {
                const optionIndex = window.productData.optionNames.indexOf(optionName);
                if (optionIndex >= 0) {
                  const variantOptionValue = variant.options[optionIndex];
                  if (variantOptionValue !== selectedOptions[optionName]) {
                    matches = false;
                  }
                }
              });
              
              if (matches) {
                matchingVariant = variant;
                break;
              }
            }
          }
          
          if (matchingVariant) {
            // Update the hidden variant ID input
            const variantIdInput = document.querySelector('input[name="id"]');
            if (variantIdInput) {
              const oldValue = variantIdInput.value;
              variantIdInput.value = matchingVariant.id;
              
              // Update URL
              const currentUrl = new URL(window.location);
              currentUrl.searchParams.set('variant', matchingVariant.id);
              window.history.replaceState(null, '', currentUrl.toString());
              
              // Update add to cart button
              const addToCartBtn = document.querySelector('[name="add"], .product-form__cart-submit');
              if (addToCartBtn) {
                addToCartBtn.disabled = !matchingVariant.available;
                if (!matchingVariant.available) {
                  addToCartBtn.textContent = 'Sold Out';
                } else {
                  addToCartBtn.textContent = 'Add to Cart';
                }
              }
              
              // ALWAYS trigger the media gallery with the correct variant (even if ID hasn't changed)
              // BUT NOT the price system since product-variant-sync.js handles that
              if (matchingVariant.featured_media) {
                const productSection = document.querySelector('.js-product');
                if (productSection) {
                  // Dispatch both events to ensure media gallery updates
                  const mediaEvent = new CustomEvent('on:variant:change', {
                    detail: { variant: matchingVariant },
                    bubbles: true
                  });
                  productSection.dispatchEvent(mediaEvent);
                  
                  const mediaOnlyEvent = new CustomEvent('on:variant:change:media-only', {
                    detail: { variant: matchingVariant },
                    bubbles: true
                  });
                  productSection.dispatchEvent(mediaOnlyEvent);
                }
                
                const mediaGallery = document.querySelector('media-gallery');
                if (mediaGallery) {
                  const galleryEvent = new CustomEvent('on:variant:change', {
                    detail: { variant: matchingVariant },
                    bubbles: true
                  });
                  mediaGallery.dispatchEvent(galleryEvent);
                }
              }
            }
          }
        }, 50);
      }
    });
  });

  // Set initial states and make all options clickable
  
  // Make all size options clickable (remove disabled state)
  const allSizeInputs = document.querySelectorAll('input[data-option-name="Size"]');
  allSizeInputs.forEach(input => {
  input.disabled = false;
  const label = document.querySelector(`label[for="${input.id}"]`);
  if (label) {
      label.style.cursor = 'pointer';
  }
  });
  
  // Set initial color state
  const checkedColorInput = document.querySelector('input[data-option-name="Color"]:checked, input[data-option-name="Colour"]:checked');
  if (checkedColorInput) {
    updateOptionAvailability('Size', 'Color', checkedColorInput.value);

  // Update color text display
  const colorTextElement = document.querySelector('.js-color-text');
  if (colorTextElement) {
      colorTextElement.textContent = checkedColorInput.value;
  }

  // Set visual selection on color swatch
  const selectedSwatch = document.querySelector(`label[for="${checkedColorInput.id}"]`);
  if (selectedSwatch) {
      selectedSwatch.classList.add('is-selected');
  }
  } else {
  }
  
  // Set initial size state
  const checkedSizeInput = document.querySelector('input[data-option-name="Size"]:checked');
  if (checkedSizeInput) {
  // Update size text display
  const sizeTextElement = document.querySelector('.js-size-text');
  if (sizeTextElement) {
      sizeTextElement.textContent = checkedSizeInput.value;
  }

  // Set visual selection on size option
  const selectedSizeLabel = document.querySelector(`label[for="${checkedSizeInput.id}"]`);
  if (selectedSizeLabel) {
      selectedSizeLabel.classList.add('is-selected');
  }
  }

  // Set visual states for all initially checked options
  const allCheckedInputs = document.querySelectorAll('input[data-option-name]:checked');
  allCheckedInputs.forEach(input => {
  const label = document.querySelector(`label[for="${input.id}"]`);
  if (label) {
      label.classList.add('is-selected');
  }
  });
  
  // Monitor if media gallery is receiving our events
  const mediaGallery = document.querySelector('media-gallery');
  if (mediaGallery) {
  // Listen for our dispatched events to see if they're being received
  mediaGallery.addEventListener('on:variant:change:media-only', function(e) {
      if (e.detail && e.detail.variant && e.detail.variant.featured_media) {
      // Check if there's a matching image element
      const matchingImage = document.querySelector(`[data-media-id="${e.detail.variant.featured_media.id}"]`);
      if (matchingImage) {
          // Image found and activated
      } else {
          // Image not found - could add fallback logic here if needed
      }
      }
  });
  } else {
  // No media-gallery element found - could add fallback logic here if needed
  }

  // Initial variant availability check on load
  const variantIdInput = document.querySelector('input[name="id"]');
  if (variantIdInput) {
    const currentVariantId = parseInt(variantIdInput.value);
    const currentVariant = window.productData.variants.find(v => v.id === currentVariantId);
    if (currentVariant) {
      const addToCartBtn = document.querySelector('[name="add"], .product-form__cart-submit');
      if (addToCartBtn) {
        addToCartBtn.disabled = !currentVariant.available;
        if (!currentVariant.available) {
          addToCartBtn.textContent = 'Sold Out';
        } else {
          addToCartBtn.textContent = 'Add to Cart';
        }
      }
    }
  }

}); // End of DOMContentLoaded

// Enhanced general change handler with logging
document.addEventListener('change', function(e) {
  if (e.target.matches('input[data-option-name]')) {
    const optionName = e.target.dataset.optionName;
    const optionPosition = e.target.dataset.optionPosition;
    const selectedValue = e.target.value;

    const labelValueSpan = document.querySelector(`.option-selector__label-value[data-option-position="${optionPosition}"]`);
    if (labelValueSpan) {
      labelValueSpan.textContent = selectedValue;
    }

    // Update visual selection for any option type
    const allLabelsInGroup = document.querySelectorAll(`input[data-option-name="${optionName}"] + label`);
    allLabelsInGroup.forEach(label => {
    label.classList.remove('is-selected');
    });
    
    const currentLabel = document.querySelector(`label[for="${e.target.id}"]`);
    if (currentLabel) {
    currentLabel.classList.add('is-selected');
    }

    // Update size text display
    if (optionName === 'Size') {
      const sizeTextElement = document.querySelector('.js-size-text');
      if (sizeTextElement) {
        sizeTextElement.textContent = selectedValue;
      }
    }

    // VARIANT SYNC for size changes
    setTimeout(() => {
      const selectedOptions = {};
      document.querySelectorAll('input[data-option-name]:checked').forEach(inp => {
        selectedOptions[inp.dataset.optionName] = inp.value;
      });
      
      let matchingVariant = null;
      if (window.productData && window.productData.variants) {
        for (const variant of window.productData.variants) {
          let matches = true;
          
          Object.keys(selectedOptions).forEach(optionName => {
            const optionIndex = window.productData.optionNames.indexOf(optionName);
            if (optionIndex >= 0) {
              const variantOptionValue = variant.options[optionIndex];
              if (variantOptionValue !== selectedOptions[optionName]) {
                matches = false;
              }
            }
          });
          
          if (matches) {
            matchingVariant = variant;
            break;
          }
        }
      }
      
      if (matchingVariant) {
        const variantIdInput = document.querySelector('input[name="id"]');
        if (variantIdInput) {
          variantIdInput.value = matchingVariant.id;
        }
        
        // Update URL with both variant and size parameters
        const currentUrl = new URL(window.location);
        currentUrl.searchParams.set('variant', matchingVariant.id);
        
        // Update size parameter to match the actual selected size
        if (matchingVariant.options && matchingVariant.options[1]) { // sizeIdx = 1
          currentUrl.searchParams.set('size', matchingVariant.options[1]);
        }
        
        window.history.replaceState(null, '', currentUrl.toString());
        
        // Trigger media gallery if variant has featured media
        // BUT NOT the price system since product-variant-sync.js handles that
        if (matchingVariant.featured_media) {
          const productSection = document.querySelector('.js-product');
          if (productSection) {
            // Dispatch both events to ensure media gallery updates
            const mediaEvent = new CustomEvent('on:variant:change', {
              detail: { variant: matchingVariant },
              bubbles: true
            });
            productSection.dispatchEvent(mediaEvent);
            
            const mediaOnlyEvent = new CustomEvent('on:variant:change:media-only', {
              detail: { variant: matchingVariant },
              bubbles: true
            });
            productSection.dispatchEvent(mediaOnlyEvent);
          }
        }
      } else {
        console.warn('No matching variant found for selections');
      }
    }, 50);
  }
});

// Listen for all option changes to update displays
document.addEventListener('change', function(e) {

if (e.target.matches('input[data-option-name="Color"], input[data-option-name="Colour"]')) {
    updateOptionAvailability('Size', 'Color', e.target.value);
}

// Handle other option changes (like direct radio button clicks)
if (e.target.matches('input[data-option-name]')) {
    const optionName = e.target.dataset.optionName;
    
    // Update visual selection for any option type
    const allLabelsInGroup = document.querySelectorAll(`input[data-option-name="${optionName}"] + label`);
    allLabelsInGroup.forEach(label => {
    label.classList.remove('is-selected');
    });
    
    const currentLabel = document.querySelector(`label[for="${e.target.id}"]`);
    if (currentLabel) {
    currentLabel.classList.add('is-selected');
    }
    
    // Trigger URL update for size changes
    if (optionName === 'Size') {
        setTimeout(() => {
            const selectedOptions = {};
            document.querySelectorAll('input[data-option-name]:checked').forEach(inp => {
                selectedOptions[inp.dataset.optionName] = inp.value;
            });
            
            let matchingVariant = null;
            if (window.productData && window.productData.variants) {
                for (const variant of window.productData.variants) {
                    let matches = true;
                    
                    Object.keys(selectedOptions).forEach(optionName => {
                        const optionIndex = window.productData.optionNames.indexOf(optionName);
                        if (optionIndex >= 0) {
                            const variantOptionValue = variant.options[optionIndex];
                            if (variantOptionValue !== selectedOptions[optionName]) {
                                matches = false;
                            }
                        }
                    });
                    
                    if (matches) {
                        matchingVariant = variant;
                        break;
                    }
                }
            }
            
            if (matchingVariant) {
                const variantIdInput = document.querySelector('input[name="id"]');
                if (variantIdInput) {
                    variantIdInput.value = matchingVariant.id;
                }
                
                // Update URL with both variant and size parameters
                const currentUrl = new URL(window.location);
                currentUrl.searchParams.set('variant', matchingVariant.id);
                
                // Update size parameter to match the actual selected size
                if (matchingVariant.options && matchingVariant.options[1]) { // sizeIdx = 1
                  currentUrl.searchParams.set('size', matchingVariant.options[1]);
                }
                
                window.history.replaceState(null, '', currentUrl.toString());
            } else {
            }
        }, 10);
    }
}
});

// Listen for clicks on color swatch labels
document.addEventListener('click', function(e) {
  if (e.target.matches('.opt-label--swatch')) {
    const inputId = e.target.getAttribute('for');
    const input = document.getElementById(inputId);
    if (input && input.dataset.optionName === 'Color') {
      updateOptionAvailability('Size', 'Color', input.value);
    }
  }
});
